import React, { useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import { svg } from '../assets/svg/common.js'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from "react-redux";
import { toast, Bounce } from 'react-toastify';
import { editorConstant } from '../helper/staticHelper.js';
import { useLoading } from '../context/LoadingContext';
import Swal from 'sweetalert2';
import { sendEmail, storeDraft, updateDraft } from '../helper/apiHelper.js'
import { getGeneralSettings, getSignature } from '../helper/apiHelper.js'

const ComposeBox = () => {
    const [theme] = useState('snow');
    const [isCc, setIsCc] = useState(false);
    const [isBcc, setIsBcc] = useState(false);
    const [isCompose, setIsCompose] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [recipient, setRecipient] = useState(localStorage.getItem('recipient') || '');
    const [cc, setCc] = useState(localStorage.getItem('cc') || '');
    const [bcc, setBcc] = useState(localStorage.getItem('bcc') || '');
    const [subject, setSubject] = useState(localStorage.getItem('subject') || '');
    const [message, setMessage] = useState(localStorage.getItem('message') || '');
    const [isSpellCheck, setIsSpellCheck] = useState(false);
    const [isMinimize, setIsMinimize] = useState(false);
    const { showLoader, hideLoader } = useLoading();
    const getIsCompose = useSelector((state) => state.isCompose);
    const refreshMessage = useSelector((state) => state.refreshMessage);
    const triggerDraft = useSelector((state) => state.triggerDraft);
    const isDraft = useSelector((state) => state.isDraft);
    const dispatch = useDispatch();

    useEffect(() => {
        const updateStateFromLocalStorage = () => {
            setIsCompose(getIsCompose);
            setRecipient(localStorage.getItem('recipient') || '');
            setCc(localStorage.getItem('cc') || '');
            setBcc(localStorage.getItem('bcc') || '');
            setSubject(localStorage.getItem('subject') || '');
            setMessage(localStorage.getItem('message') || '');
            setIsCc(localStorage.getItem('cc') ? true : false);
            setIsBcc(localStorage.getItem('bcc') ? true : false);
            setSelectedFiles([]);
            setIsMinimize(false);
        };
        updateStateFromLocalStorage();
        const handleRecipientChange = (event) => {
            setRecipient(localStorage.getItem('recipient') || '');
        };
        if (getIsCompose) {
            fetchData();
        }
        window.addEventListener('clickQuickSent', handleRecipientChange);
        return () => {
            window.removeEventListener('clickQuickSent', handleRecipientChange);
        };
    }, [getIsCompose, triggerDraft]);

    const fetchData = async () => {
        const response = await getGeneralSettings();
        const getsign = await getSignature();
        if (response) {
            setIsSpellCheck(response.is_spell_check);
        } else {
            setIsSpellCheck(false);
        }
        if (getsign && getsign.is_active) {
            if (getsign.is_html) {
                setMessage(localStorage.getItem('message') + `<div>
        <p><br></p> 
        <p><br></p>${decodeHtml(getsign.signature)}</div>`);
            } else {
                setMessage(localStorage.getItem('message') + `<div>
        <p><br></p> 
        <p><br></p>${getsign.signature}</div>`);
            }
        }
    }

    const decodeHtml = (html) => {
        const textArea = document.createElement("textarea");
        textArea.innerHTML = html;
        return textArea.value;
    };

    useEffect(() => {
        const editor = document.querySelector('.ql-editor');

        if (editor) {
            editor.focus();
            editor.setAttribute('spellcheck', isSpellCheck);
        }
    }, [message]);


    useEffect(() => {
        localStorage.setItem('recipient', recipient);
        localStorage.setItem('cc', cc);
        localStorage.setItem('bcc', bcc);
        localStorage.setItem('subject', subject);
        localStorage.setItem('message', message);
    }, [recipient, cc, bcc, subject, message]);

    const handleFileChange = async (event) => {
        const newFiles = Array.from(event.target.files);
        const combinedFiles = [...selectedFiles, ...newFiles];
        const maxSize = 25 * 1024 * 1024; // 25 MB in bytes
        const totalSize = combinedFiles.reduce((acc, file) => acc + file.size, 0);
        if (totalSize > maxSize) {
            toast.error("Total file size exceeds the limit of 25 MB.", {
                position: "top-center",
                transition: Bounce,
            });
            return;
        }
        setSelectedFiles(combinedFiles);
        handleHeight(combinedFiles);
    };

    const handleRemoveFile = async (indexToRemove) => {
        const updatedFiles = selectedFiles.filter((file, index) => index !== indexToRemove);
        setSelectedFiles(updatedFiles);
        handleHeight(updatedFiles);
    }

    const handleHeight = (files) => {
        const editor = document.querySelector('.quil-text-editor .quill');
        if (files.length) {
            editor.style.gap = '80px';
        } else {
            editor.style.gap = '10px';
        }
    }

    async function composeEmail() {
        showLoader();
        const emailRecipient = recipient;
        const emailSubject = subject;
        const emailCc = isCc ? cc : "";
        const emailBcc = isBcc ? bcc : "";

        let isReceipientAdded = false;
        if (emailRecipient || emailCc || emailBcc) isReceipientAdded = true;
        if (!isReceipientAdded) {
            toast.error("Please specify at least one recipient.", {
                position: "top-center",
                transition: Bounce,
            });
            hideLoader();
            return;
        }
        if (!emailSubject || !message) {
            Swal.fire({
                text: "Send this message without a subject or text in the body?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#1677ff",
                cancelButtonColor: "#ffffff",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                customClass: "compose-sweet-alert",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await sendEmailProcess();
                } else {
                    hideLoader();
                    return true;
                }
            });
        } else {
            await sendEmailProcess();
        }
    }

    const sendEmailProcess = async () => {
        const emailObject = {
            recipient: recipient.replace(/\s/g, "").split(","),
            cc: cc.replace(/\s/g, "").split(","),
            bcc: bcc.replace(/\s/g, "").split(","),
            subject: subject,
            message: message,
            attachment: selectedFiles
        };
        const result = await sendEmail(emailObject);
        if (result) {
            toast.success("Message sent", {
                position: "top-center",
                transition: Bounce,
            });
            dispatch({ type: "IS_COMPOSE", payload: false });
        } else {
            toast.error("Something went wrong", {
                position: "top-center",
                transition: Bounce,
            });
        }
        hideLoader();
    }

    const saveDraft = async () => {
        showLoader();
        Swal.fire({
            text: "Are you sure you want to save draft?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#ffffff",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const emailObject = {
                    recipient: recipient.replace(/\s/g, "").split(","),
                    cc: cc.replace(/\s/g, "").split(","),
                    bcc: bcc.replace(/\s/g, "").split(","),
                    subject: subject,
                    message: message,
                };
                if (!isDraft) {
                    await storeDraft(JSON.stringify(emailObject));
                } else {
                    await updateDraft(isDraft, JSON.stringify(emailObject));
                }
                dispatch({ type: "REFRESH_MESSAGE", payload: !refreshMessage });
                dispatch({ type: "IS_COMPOSE", payload: false });
            } else {
                dispatch({ type: "IS_COMPOSE", payload: false });
            }
        });
        hideLoader();
    }




    return (
        <>
            {isCompose &&
                <div>
                    {!isMinimize &&
                        <Draggable handle=".drag-icon" bounds=".parent-component-div-align">
                            <div className='compose-box-section'>
                                <div className='drag-icon-section d-flex justify-content-center'>
                                    <span className='drag-icon'></span>
                                </div>
                                <div className='compose-box-header-section d-flex justify-content-between align-items-center'>
                                    <span className='compose-text'>New Message</span>
                                    <div className='compose-icon-section d-flex gap-2'>
                                        <span className='cursor-pointer' onClick={() => {
                                            setIsMinimize(!isMinimize);
                                        }}>{svg.minus}</span>
                                        {/* <span className='cursor-pointer'>{svg.max}</span> */}
                                        <span className='cursor-pointer' onClick={async () => {
                                            await saveDraft();
                                        }}>{svg.close}</span>
                                    </div>
                                </div>
                                <div className='email-section mt-4'>
                                    <div className="email-username">
                                        {/* <span className='compose-h2-text'>Recipient:</span> */}
                                        <input className="compose-input" onChange={(e) => setRecipient(e.target.value)} value={recipient} placeholder='Recipient' />
                                        <span className='compose-h2-text cursor-pointer' onClick={() => {
                                            setIsCc(!isCc);
                                        }}>Cc</span> <span className='compose-h2-text'> | </span> <span className='compose-h2-text cursor-pointer' onClick={() => {
                                            setIsBcc(!isBcc);
                                        }}>Bcc</span>
                                    </div>
                                    {isCc && <div className="email-username mt-4">
                                        {/* <span className='compose-h2-text'>Cc:</span> */}
                                        <input className="compose-input " onChange={(e) => setCc(e.target.value)} value={cc} placeholder='Cc' /></div>}
                                    {isBcc && <div className="email-username mt-4">
                                        {/* <span className='compose-h2-text'>Bcc:</span> */}
                                        <input className="compose-input " onChange={(e) => setBcc(e.target.value)} value={bcc} placeholder='Bcc' /></div>}
                                    <div className="email-username mt-4">
                                        {/* <span className='compose-h2-text'>Subject:</span> */}
                                        <input className="compose-input " onChange={(e) => setSubject(e.target.value)} value={subject} placeholder='Subject' /></div>
                                </div>
                                <div className="quil-text-editor mt-4">
                                    <ReactQuill
                                        theme={theme}
                                        modules={{ toolbar: editorConstant.toolBar }}
                                        placeholder='Write your message here...'
                                        className='compose-quill'
                                        onChange={async (e) => { setMessage(e) }}
                                        value={message}
                                    />
                                    <div className='send-btn-section d-flex justify-content-end gap-3 align-items-center'>
                                        <span className='cursor-pointer' onClick={() => document.getElementById('fileInput').click()}>{svg.attachment}</span><span className='cursor-pointer'>{svg.delete}</span>
                                        <input
                                            type="file"
                                            id="fileInput"
                                            multiple
                                            style={{ display: 'none' }}
                                            onChange={handleFileChange}
                                        />
                                        <button className='send-btn' onClick={async () => {
                                            composeEmail();
                                        }}><span className='compose-btn-text'>{svg.sent_icon} Send</span></button>
                                    </div>
                                </div>
                                {selectedFiles.length > 0 && (
                                    <div className="attachment-section-element">
                                        {selectedFiles.map((file, index) => (
                                            <a key={index}>{file.name} <span className="delete-icon cursor-pointer" onClick={() => handleRemoveFile(index)}> &#10006;
                                            </span></a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </Draggable>
                    }
                    {isMinimize &&
                        <Draggable handle=".minimise-compose-div-element" bounds=".parent-component-div-align">
                            <div className="minimise-compose-div-element cursor-move">
                                <div className="compose-new-message-txt"> New Message </div>
                                <div className="cursor-pointer d-flex justify-content-center align-items-center gap-2" >
                                    <div onClick={() => {
                                        setIsMinimize(!isMinimize);
                                    }}>{svg.max}</div>
                                    <div className='cursor-pointer' onClick={async () => {
                                        await saveDraft();
                                    }}>{svg.close}</div>
                                </div>
                            </div>
                        </Draggable>
                    }
                </div>
            }
        </>
    );
};


export default ComposeBox;
